import a, { forwardRef as n } from "react";
import { IconButton as i } from "./icon-button.js";
import { MdClose as l } from "@react-icons/all-files/md/MdClose";
const m = n(
  ({ children: t, onClick: o, ariaLabel: e }, r) => /* @__PURE__ */ a.createElement(
    i,
    {
      ref: r,
      "data-testid": "close-button",
      "aria-label": e,
      icon: l,
      variant: "tertiary",
      onClick: o
    },
    t
  )
);
m.displayName = "CloseButton";
export {
  m as CloseButton
};
